<template>
    <HeaderComponent title="Add Report" :actions="[
        {label: 'Save Report', click: () => addReport(), class: 'bg-green-500 text-white'}, 
    ]"/>
    <FormKit type="form" submit-label="Add Report" @submit="addReport" :actions="false">
        <FormKit type="text" name="type" label="Type" v-model="form.type" />
        <FormKit
            type="text"
            name="period"
            label="Period"
            v-model="form.period"
        />
        <FormKit
            type="text"
            name="description"
            label="Description"
            v-model="form.description"
        />
        <FormKit
            type="number"
            name="amount"
            label="Amount"
            v-model="form.amount"
        />
        <FormKit
            type="datetime-local"
            name="created"
            label="Created"
            v-model="form.created"
        />
    </FormKit>
</template>

<script setup>
import { usePage, router } from "@inertiajs/vue3";
import { computed, ref, watch } from "vue";
import { FormKit } from "@formkit/vue";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const affiliate = computed(() => page.props.affiliate);
const customDate = ref(false);

const form = ref({
    type: "",
    period: "",
    description: "",
    amount: 0,
    created: new Date().toISOString().slice(0, 16),
});

watch(form, (newVal, oldVal) => {
    if (newVal.created !== oldVal.created) {
        customDate.value = true;
    }
});

setInterval(() => {
    if (!customDate.value) {
        form.value.created = new Date().toISOString().slice(0, 16);
    }
}, 1000 * 10);



const addReport = () => {
    router.post(
        `/admin/affiliate-reports/add/${affiliate.value.short_uuid}`,
        {
            affiliateReport: form.value,
        },
        {
            headers: {
                "X-CSRF-Token": page.props.csrfToken,
            },
        },
    );
};
</script>
